import {
  SET
} from 'reducer/types/prefix'

export const PROVIDER = 'PROVIDER'

export const SET_PROVIDER = `${SET}${PROVIDER}`